import React from "react";
import { teamGroupTeamsMappingsApi } from "@/apis/apis";
import { columns } from "./Columns";
import MappingBaseTable from "../BaseTable";
import { BASE_IMPORT_DATA } from "@/Modals/WebDataManagement/Mapping/BaseImport/baseImportData";
import TeamGroupTeamModal from "@/Modals/WebDataManagement/Mapping/TeamGroupTeam/Modal";
import { useFilters } from "./Filters";

export default function TeamGroupTeamPage() {
  const filters = useFilters();

  return (
    <MappingBaseTable
      label="Team Group - Team"
      apiURL={teamGroupTeamsMappingsApi}
      columns={columns()}
      filters={filters}
      ModalComponent={TeamGroupTeamModal}
      importData={BASE_IMPORT_DATA.TEAM_GROUP_TEAM}
      enableAdd={false}
      enableEdit={true}
      enableDelete={false}
      enableSortData={true}
    />
  );
}
